import React, { useRef } from 'react';
import PropTypes from 'prop-types';

const Unify = ({ userType, unifyToken, unifyUrl }) => {
  const iframeLoaded = useRef(false);
  const iframeRef = useRef();

  const sendToIframeUnify = () => {
    if (iframeRef.current && iframeRef.current.contentWindow) {
      iframeRef.current.contentWindow.postMessage(
        {
          type: 'SET_TOKEN',
          token: unifyToken,
          tokenUserType: userType,
        },
        `${unifyUrl}/${userType}`
      );
    }
  };

  const IframeWithScopeUnify = () => {
    const url = new URL(`${unifyUrl}/${userType}`);
    url.searchParams.append('scope', window.location.origin);
    const iframeUrl = url.toString();

    const handleIframeLoad = () => {
      iframeLoaded.current = true;
      if (unifyToken) {
        sendToIframeUnify();
      }
    };

    return (
      <iframe
        ref={iframeRef}
        src={iframeUrl}
        onLoad={handleIframeLoad}
        style={{
          height: 'calc(100% - 18px)',
          width: 'calc(100% - 5px)',
          border: 'none',
          borderRadius: '8px',
          margin: '5px 5px 5px 0',
        }}
        sandbox='allow-same-origin allow-scripts allow-forms allow-popups allow-downloads allow-modals allow-popups-to-escape-sandbox allow-presentation allow-top-navigation-by-user-activation'
        allow='clipboard-write; clipboard-read'
      />
    );
  };

  return <div className='content'>{IframeWithScopeUnify()}</div>;
};

Unify.propTypes = {
  userType: PropTypes.string,
  unifyToken: PropTypes.string,
  unifyUrl: PropTypes.string,
};

export default Unify;
